export default {
  widgets: {
    pilotOffers: "Pilot offers",
    auctions: "Marketplace",
    departmentList: "My departments",
    warehouseList: "My warehouses",
    documentList: "My documents",
    leasingList: "Leasing",
    driverList: "Drivers",
    workerList: "Employees",
    groupList: "My groups",
    monitoryArchive: "Notification archive",
    companyData: "Company",
    outsideWarehouse: "External warehouses",
    auctionParticipants: "Listing participants",
    auctionArchive: "Listing archive",
    walletTimeWindows: "Time windows",
    walletSub: "Subscription",
    invoicesList: "Invoices",
    factoring: "Factoring",
    transports: "Transports",
    surcharges: "Surcharges",
    currentAuctionsAvailable: "Orders",
  },
};
